/**
 * 主页技能详细信息
 * */
import React, { PureComponent } from 'react';
import { withRouter } from '../../WithRouterHOC';
import { Modal, Button, Popover } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import Util from '../../../script/util';
import Scrollbar from 'react-scrollbars-custom';
import HTTP from '../../../script/service';
import { DDEmpty, DDLoading } from '../../globalPageStatus';
import SkillAudio from './SkillAudio';
import { debounce } from 'lodash-es';
import HideComm from '../hideComm/HideComm';
import { PopoverEight, PopoverGiveFull, SkillUnitPrice } from './DiscountsTip';
import Song from '../song/Song';
import { _dssp_send_click } from '../../../store/Action';
import './SkillDetailModal.scss';

class SkillDetailModal extends PureComponent {
  state = {
    visible: false,
    loading: false, // 加载中
    favorableRate: 0, // 好评率
    commentList: [], // 评论列表
    commentParam: {
      // 评论参数
      page: 0,
      size: 10,
      more: true,
      total: 0,
      hideNum: 0,
    },
  };

  //获取用户评论
  getUserComment = (reset = false) => {
    const { dsid, selCat } = this.props;
    let { commentList, commentParam } = this.state;
    if (reset) {
      commentParam.page = 0;
      commentParam.more = true;
      commentList = [];
    }
    if (!commentParam.more) return false;
    commentParam.uid = dsid;
    commentParam.categoryId = selCat.categoryId;
    commentParam.page += 1;
    this.setState({ loading: true }, () => {
      HTTP._get_user_comment_wall(commentParam)
        .then((res) => {
          if (res.code == 200 && res.data) {
            commentList = commentList.concat(res.data.commentList);
            commentParam.total = res.data.totalNum;
            commentParam.score = res.data.score;
            const favorableRate = res.data.favorableRate;
            commentParam.hideNum = res.data.hideNum;
            if (commentList.length >= res.data.totalNum) {
              commentParam.more = false;
            } else {
              commentParam.more = true;
            }
            this.setState({
              commentList: [...commentList],
              commentParam: { ...commentParam },
              favorableRate,
            });
          }
        })
        .finally(() => {
          this.setState({ loading: false });
        });
    });
  };

  // 展示弹窗
  showModal = ({ num }) => {
    this.setState(
      {
        visible: true,
      },
      () => {
        this.getUserComment();
      }
    );
  };

  // 隐藏弹窗
  hideModal = () => {
    this.setState({
      visible: false,
      commentList: [],
      commentParam: {
        page: 0,
        size: 10,
        more: true,
        total: 0,
        hideNum: 0,
      },
      favorableRate: 0,
    });
  };

  //评论隐藏规则
  showNideCommRemark = () => {
    this.hideCommElement.showModal();
  };

  // 滚动条
  handleScroll = debounce((e) => {
    if (e.scrollHeight - (e.scrollTop + e.clientHeight) < 10) {
      this.getUserComment(false);
    }
  }, 600);

  // 评价等级ICON
  renderRateIcon = (item) => {
    const { base } = this.props;
    const { commentEnum } = base;
    const curStar = commentEnum.find((_item) => _item.id === item.star);

    return (
      <div className="pf-lv">
        <span className={`icon-star icon-star-${item.star}`} />
        <span>{curStar.text}</span>
      </div>
    );
  };

  render() {
    const {
      base,
      dsid,
      ehot,
      hasGivefull,
      selCat,
      openNimChat,
      addOrder,
      skillOrderNum,
      changeSkillNum,
    } = this.props;
    const { visible, loading, commentList, commentParam, favorableRate } =
      this.state;
    return (
      <>
        <Modal
          open={visible}
          wrapClassName="skill-details-modal"
          centered
          footer={null}
          width={950}
          onCancel={this.hideModal}
        >
          {selCat && (
            <>
              <div className="skill-detail-header">
                <div className="skill-cover">
                  <img
                    src={Util.transImgUrl(selCat.icon ?? null, '60x60')}
                    alt={selCat.categoryName}
                  />
                </div>
                <div className="skill-info">
                  <div className="skill-name">
                    {selCat.categoryName} <SkillAudio selCat={selCat} />
                  </div>
                  {selCat?.level && (
                    <div className="skill-level">
                      <span>技能等级:</span>
                      <span className="level-tag">
                        <span
                          className="skill-mini-cover"
                          style={{
                            backgroundImage: `url(${Util.transImgUrl(selCat.icon, '20x20')})`,
                          }}
                        />
                        <label>{selCat.level}</label>
                      </span>
                    </div>
                  )}
                </div>
              </div>
              <div className="ds-main-bottom-divider" />
              <div className="skill-detail-center">
                <Scrollbar onScroll={this.handleScroll}>
                  {!!selCat?.hasSongSheet && <Song base={base} uid={dsid} />}
                  <div className="skill-details-info">
                    <div className="left-center">
                      {selCat?.serviceTime && (
                        <div className="skill-ask-line">
                          <p className="skill-label">接单时间</p>
                          <p className="skill-value">
                            {selCat?.serviceTime ?? '无'}
                          </p>
                        </div>
                      )}
                      {selCat?.orderArea && (
                        <div className="skill-ask-line">
                          <p className="skill-label">接单大区</p>
                          <p className="skill-value">
                            {selCat.orderArea ?? '无'}
                          </p>
                        </div>
                      )}
                      {selCat?.goodLocation && (
                        <div className="skill-ask-line">
                          <p className="skill-label">擅长位置</p>
                          <p className="skill-value">
                            {selCat.goodLocation ?? '无'}
                          </p>
                        </div>
                      )}
                      {selCat?.orderRemark && (
                        <div className="skill-ask-line">
                          <p className="skill-label">接单说明</p>
                          <p className="skill-value">
                            {selCat.orderRemark ?? '无'}
                          </p>
                        </div>
                      )}
                    </div>
                    <div className="right-center">
                      <img
                        src={Util.transImgUrl(selCat?.skillPic ?? null)}
                        alt={selCat?.level ?? 0}
                      />
                    </div>
                  </div>
                  <div className="ds-main-bottom-divider" />
                  {/* 技能评价 */}
                  <DDLoading status={loading}>
                    <div className="skill-detail-rate">
                      <div className="header">
                        <h4>
                          <span className="icon-title" />
                          用户评价
                          <span>共{selCat?.totalCommentNum ?? 0}条评价</span>
                        </h4>
                        {favorableRate ? (
                          <p className="rate-ratio">
                            好评率 <span className="num">{favorableRate}%</span>
                          </p>
                        ) : (
                          <p className="rate-ratio">暂无评分</p>
                        )}
                      </div>
                      {commentList?.length
                        ? commentList.map((item, index) => (
                            <div key={index} className="rate-line">
                              <div className="user-avatar">
                                <img
                                  src={Util.transImgUrl(item.avatar, '48x48')}
                                  alt="用户名称"
                                />
                              </div>
                              <div className="user-info">
                                <div className="line">
                                  <div className="left">
                                    <h4 className="user-nick">
                                      <span className="nick">
                                        {item.nickname}
                                      </span>
                                      {
                                        <i
                                          className={`icon-wealth v_${item.wealthLevel}`}
                                        />
                                      }
                                      {
                                        <i
                                          className={`icon-charm v_${item.glamourLevel}`}
                                        />
                                      }
                                      <i
                                        className={`icon-sea v_${item.nobleLevel}`}
                                      />
                                    </h4>
                                    <p className="rate-time">
                                      <span>
                                        {Util.dateFormat(
                                          item.commentTime,
                                          'MM-DD HH:mm'
                                        )}
                                      </span>
                                      {item.sourcePlace && (
                                        <span>{item.sourcePlace}</span>
                                      )}
                                    </p>
                                  </div>
                                  <div className="rate-score">
                                    {this.renderRateIcon(item)}
                                  </div>
                                </div>
                                <div className="line">
                                  <p className="rate-content">{item.content}</p>
                                </div>
                              </div>
                            </div>
                          ))
                        : !loading && <DDEmpty description="暂无用户评价" />}
                      {commentList &&
                      commentList.length &&
                      commentParam.more ? (
                        <div
                          className="more-data"
                          onClick={() => this.getUserCommentWall(false)}
                        >
                          查看更多评论
                        </div>
                      ) : (
                        <div className="hide-comm">
                          {!commentParam.more && commentParam.hideNum ? (
                            <span onClick={this.showNideCommRemark}>
                              <label>
                                有{commentParam.hideNum}条评论被隐藏
                              </label>
                              <QuestionCircleOutlined />
                            </span>
                          ) : null}
                        </div>
                      )}
                    </div>
                  </DDLoading>
                </Scrollbar>
              </div>
              {/* 下单页脚 */}
              <div className="skill-footer">
                <div className="left">
                  <SkillUnitPrice
                    lang={base.rootConfig.lang}
                    price={selCat.price}
                  />
                  <div className="skill-order-num">
                    <span
                      className="reduce"
                      onClick={() => changeSkillNum(-1)}
                    />
                    <span className="number">{skillOrderNum}</span>
                    <span className="plus" onClick={() => changeSkillNum(1)} />
                  </div>
                  {/* 买2送1 */}
                  {selCat.fullGiveStutas && !hasGivefull ? (
                    <PopoverGiveFull />
                  ) : null}
                  {/* 八元优惠提示 */}
                  {!!ehot && <PopoverEight />}
                </div>

                <div className="right">
                  <Popover
                    rootClassName="daidai-popover-default"
                    content={<div className="order-flow-tip" />}
                  >
                    <span className="btn-skill-flow">
                      <i className="icon-information" />
                      交易流程
                    </span>
                  </Popover>
                  <Button
                    className="daidai-btn-primary btn-skill-chat"
                    onClick={() => {
                      openNimChat();
                      _dssp_send_click(91, {
                        to: dsid,
                        action: 'im-detail',
                      });
                    }}
                  >
                    {/*聊一聊*/}
                  </Button>
                  <Button
                    className="daidai-btn-primary btn-skill-pay"
                    onClick={() => {
                      addOrder();
                      _dssp_send_click(91, {
                        to: dsid,
                        action: 'order-detail',
                      });
                    }}
                  >
                    立即下单
                  </Button>
                </div>
              </div>
            </>
          )}
        </Modal>

        {/* 评论隐藏规则 */}
        <HideComm wrappedComponentRef={(el) => (this.hideCommElement = el)} />
      </>
    );
  }
}

export default withRouter(SkillDetailModal, { withRef: true });
